import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";
import { AmplifyLoginFields, AwsConfigAuth } from "../config/auth";
import { AmplifyUICustomComponents } from "../components/AmplifyUI";
import { AuthState } from "../types/AmplifyAuth";
import { Spinner } from "@idwal/idwal-react-components";
import { AmplifyServices } from "../services/amplify";
import { Message } from "primereact/message";
import { useTranslation } from "react-i18next";
import { AuthRoutes } from "../routes/authRoutes";

Amplify.configure(AwsConfigAuth);

interface IAuthWrapper {
    authState: AuthState;
}

/**
 * Wrapper to prevent code duplication
 * The Amplify Auth component takes an intial state than cannot
 * be driven off of state
 * @param authState signIn | resetPassword | signUp
 * @returns
 */
export const AuthWrapper = ({ authState }: IAuthWrapper) => {
    const { t } = useTranslation("locale");
    const { route } = useAuthenticator((context) => [context.route]);

    const getMigrationText = () => {
        return (
            <p>
                {t("application.surveyor_text_pre_link")}{" "}
                <a
                    href="https://www.idwalmarine.com/surveyors"
                    style={{ color: "#008094" }}
                >
                    {t("application.surveyor_text_link")}
                </a>
            </p>
        );
    };

    return (
        <>
            {route !== AuthRoutes.Authenticated ? (
                <div className="flex justify-content-center pb-6">
                    <Message
                        severity="warn"
                        className="col-12 md:col-8 lg:col-8"
                        text={getMigrationText}
                    ></Message>
                </div>
            ) : null}
            <Authenticator
                initialState={authState}
                formFields={AmplifyLoginFields.Fields()}
                signUpAttributes={["phone_number"]}
                components={AmplifyUICustomComponents}
                services={AmplifyServices.Services()}
            >
                {() => (
                    <main>
                        <div className="h-3rem w-3rem">
                            <Spinner width={50} height={50} />
                        </div>
                    </main>
                )}
            </Authenticator>
        </>
    );
};
